import { LogLevel, type Configuration, type PopupRequest } from '@azure/msal-browser';

/**
 * Entra ID konfiguráció a webes SPA-hoz (auth code + PKCE).
 *
 * A tenant és az API azonosítói NEM titkok — publikus kliens-azonosítók,
 * ugyanezek szerepelnek a `docs/entra-spike.md`-ben és az Android
 * `msal_config.json`-ban is. Ettől függetlenül build-időben felülírhatók
 * (`VITE_*`), hogy egy másik tenantba telepítéshez ne kelljen kódot írni.
 */
const TENANT_ID = import.meta.env.VITE_ENTRA_TENANT_ID ?? 'fab81a52-f6fd-4f96-a786-fec01c4543bf';
const CLIENT_ID = import.meta.env.VITE_ENTRA_WEB_CLIENT_ID ?? 'a11ce99b-5f7f-4c4f-b97b-52a050f86165';
const API_APP_ID = import.meta.env.VITE_ENTRA_API_APP_ID ?? '11680840-7b0f-48ab-99a6-bb6510cfb103';

/**
 * A backend `scp` claimben pontosan ezt várja (`jwt.strategy.ts`), és enélkül
 * `FORBIDDEN`-t ad — nem elég, hogy a token a helyes tenantból származik.
 */
export const API_SCOPE = `api://${API_APP_ID}/access_as_user`;

export const msalConfig: Configuration = {
  auth: {
    // Tenant-specifikus authority: csak a Persped tenant jelentkezhet be.
    // A backend ezt `tid` claim alapján úgyis újraellenőrzi
    // (`INVALID_TENANT`) — ez itt csak azért van, hogy a felhasználó ne
    // egy idegen fiókkal jusson el a hibáig.
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    // Same-origin kiszolgálás: a SPA gyökere egyben a redirect URI is.
    redirectUri: window.location.origin + '/',
    postLogoutRedirectUri: window.location.origin + '/',
  },
  cache: {
    // sessionStorage: a token a fül bezárásával elvész. Egy irodai,
    // megosztott gépen ez a helyes alapértelmezés — a localStorage
    // a következő felhasználónak adná oda a munkamenetet.
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
        else if (level === LogLevel.Warning) console.warn(message);
      },
    },
  },
};

/** Bejelentkezéskor és csendes megújításkor egyaránt ezt a scope-ot kérjük. */
export const loginRequest: PopupRequest = {
  scopes: [API_SCOPE],
};
